<script lang="ts">
    import type {ChipSize} from 'shared/ui-widgets/chip/types';
    import {getFondNumberColor} from './utils';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    export let chipSize: ChipSize = 'md';
    export let fondId: number;

    const textColor = getFondNumberColor(fondId, 12);
    const backgroundColor = getFondNumberColor(fondId, 85);
</script>

<span class="sutor-fond-chip"
      style:--chip-text-color="{textColor}"
      style:--chip-background-color="{backgroundColor}">

    <KpChipTag {chipSize} additionalClasses="sutor-fond-tag">
       <slot/>
    </KpChipTag>
</span>

<style lang="less">
    :global {
        .sutor-fond-chip .sutor-fond-tag {
            background-color: var(--chip-background-color);
            color: var(--chip-text-color);
            border: 1px solid rgba(0, 0, 0, 0.125);
            transition: border-color 0.3s ease-in-out;

            a {
                color: var(--chip-text-color);
            }
        }
    }
</style>